import module from 'nominas/nomina/module.js'
import template from './template.html'

const colorWarn = '#FFECB3'
const colorError = '#EF9A9A'

export default class NominasCargaserviciosVincularComponent {
  constructor ($dialogParams, dialog, $utils, $dialog, $document, FinanzasTablaRelacional, $session) {
    this.dialog = dialog
    this.$utils = $utils
    this.$dialog = $dialog
    this.$document = $document
    this.FinanzasTablaRelacional = FinanzasTablaRelacional
    this.busqueda = $dialogParams['search']
    this.allowTablaRelacional = $session.dataTemporal.claims.indexOf('kendu.finanzas.tablaRelacional') >= 0
    this.data = null
    this.saving = false
    this.searching = false
    this.saved = false
    this.groupStatus = {}
    this.alerts = {
      error: [],
      warning: [],
    }
    this.catalogos = $dialogParams['catalogos']
    this.currentAlert = {warning: 0, error: 0}
    this.companies = [...$dialogParams['companies']]
    this.options = {
      companies: $dialogParams['selected'] || [],
      company_filter: null,
      byID: $dialogParams['idNomifan'] || false,
      decodeID: true,
    }
  }

  borrame () {
    this.options.companies = this.companies.filter((item) => item['selected'])
      .map((item) => item['ID'])
  }

  search () {
    if (!this.options.companies.length) {
      return alert('Es necesario especificar al menos una empresa.')
    }

    this.searching = true

    this.FinanzasTablaRelacional.search(this.busqueda, this.options.byID, this.options.companies)
      .then((data) => {
        this.data = data.map((row, index) => {
            let link = row.results.length > 0
              ? row.results
                .map((kardex) => this.crearLink(row.query[1], kardex))
                .reduce((prev, current) => prev && prev.match < current.match ? current : prev)
              : undefined

            return {
              index: index,
              active: true,
              query: row.query,
              link: link,
              selected: link && (link.match > 0.33),
            }
          })
          .sort((a, b) => a.name > b.name ? 1 : (a.name < b.name ? -1 : 0))

        this.validate()
      })
      .finally(() => (this.searching = false))
  }

  matchColor (row) {
    return row.selected ? (row.link.match >= 0.5 ? '' : colorWarn) : colorError
  }

  validate (row) {
    if (row) {
      row.link.match = 1
      row.selected = true
    }

    let data = this.data.filter((row) => row.active)
    this.alerts.error = data.filter((row) => !row.selected)
    this.alerts.warning = data.filter((row) => row.link && row.link.match < 0.5)
  }

  replace (row) {
    this.$dialog.show('empleado.select', {
        companies: this.companies,
        searchFor: row.query[1],
      })
      .then((kardex) => {
        row.link = this.crearLink(row.query[1], kardex)
        row.selected = true
        this.validate()

        if (this.allowTablaRelacional) {
          this.FinanzasTablaRelacional.set(kardex['ID_Empleado'], kardex['ID_Empresa'], row.query[0], row.query[1], {
            ID_Relacional: row.query[0],
            Nombre_Largo: row.query[1],
            Status: '1',
          })
        }
      })
  }

  discard (row) {
    row.active = false
    this.validate()
  }

  discardAlerts () {
    this.data.forEach((row) => (row.active = !!(row.link && row.selected)))
    this.validate()
  }

  aproveWarnings () {
    this.alerts.warning.forEach((row) => (row.link.match = 1))
    this.validate()
  }

  nextAlert (alert) {
    this.currentAlert[alert] = this.currentAlert[alert] >= this.alerts[alert].length ? 0 : this.currentAlert[alert]
    this.$document[0].getElementById('row_' + this.alerts[alert][this.currentAlert[alert]++].index).scrollIntoView()
  }

  link () {
    let array = []
    this.data
      .filter((item) => item.active)
      .forEach((item) => {
        array[item.index] = {
          UID: item.link.UID,
          Empleado: item.link.Empleado,
          Empresa: item.link.company,
          ID_Empleado: item.link.ID_Empleado,
          ID_Empresa: item.link.ID_Empresa,
        }
      })

    this.dialog.resolve(array)
  }

  cancel () {
    this.dialog.reject()
  }

  crearLink (nombre, data) {
    const opcionA = this.$utils.string.clear(nombre).toUpperCase().split(' ')
    const opcionB = this.$utils.string.clear(data['Nombre_Completo'] || data['Empleado']).toUpperCase().split(' ')

    return {
      UID: data['ID_Empleado'] + '@' + data['ID_Empresa'],
      Empleado: data['Nombre_Completo'] || data['Empleado'],
      ID_Empresa: data['ID_Empresa'],
      ID_Empleado: data['ID_Empleado'],
      Status: data['Status'],
      company: this.catalogos.Empresas[data['ID_Empresa']]['Descripcion'],
      match: this.$utils.array.compare(opcionA, opcionB),
    }
  }
}

module.controller('NominasCargaserviciosVincular', NominasCargaserviciosVincularComponent)
module.config(($dialogProvider) => {
  $dialogProvider.dialog('nominas.cargaServicios.vincular', {
    controller: 'NominasCargaserviciosVincular',
    template,
    controllerAs: '$ctrl',
    cancelable: false,
  })
})



// WEBPACK FOOTER //
// ./src/nominas/cargaservicios/components/vincular/component.js